import { FarmModel } from '@/models/farm/farm';
import { UserModel } from '@/models/user/user';
import { GroupModel } from '@/models/group/group';
import { SensorModel } from '@/models/sensor/sensor';

class ToCSV {
  data;
  parsedData;
  csvString;

  constructor(data) {
    this.data = data;
    this.parsedData = [];
    this.csvString = '';
  }

  sensorExport() {
    this.parsedData.push({
      barcode: 'Barcode',
      createdOn: 'Created On',
      battery: 'Battery',
      orchards: 'Orchards',
      lastPing: 'Last Ping',
      hasLocation: 'Location'
    });

    for (let i in this.data) {
      let farm = new SensorModel(this.data[i]);
      this.parsedData.push({
        barcode: farm.barcode,
        createdOn: farm.dateCreated,
        battery: farm.batteryLevel,
        orchards: farm.orchardCount,
        lastPing: farm.lastReported,
        hasLocation: farm.hasLocation ? 'Yes' : 'No'
      });
    }
  }

  farmExport() {
    this.parsedData.push({
      name: 'Name',
      description: 'Description',
      createdOn: 'Created On',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      timezone: 'Timezone'
    });

    for (let i in this.data) {
      let farm = new FarmModel(this.data[i]);
      this.parsedData.push({
        name: farm.name,
        description: farm.description,
        createdOn: farm.dateCreated,
        email: farm.email,
        phone: farm.phone,
        status: farm.status,
        timezone: farm.timezone
      });
    }
  }

  orchardExport() {
    this.parsedData.push({
      name: 'Name',
      description: 'Description',
      createdOn: 'Created On',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      timezone: 'Timezone'
    });

    for (let i in this.data) {
      let farm = new GroupModel(this.data[i]);
      this.parsedData.push({
        name: farm.name,
        description: farm.description,
        createdOn: farm.dateCreated,
        email: farm.email,
        phone: farm.phone,
        status: farm.status,
        timezone: farm.timezone
      });
    }
  }

  userExport() {
    this.parsedData.push({
      name: 'Name',
      createdOn: 'Created On',
      lastLogged: 'Last logged',
      email: 'Email',
      phone: 'Phone',
      status: 'Status'
    });

    for (let i in this.data) {
      let farm = new UserModel(this.data[i]);
      this.parsedData.push({
        name: farm.name,
        createdOn: farm.dateJoined,
        lastLogged: farm.dateLastLogged,
        email: farm.email,
        phone: farm.phone,
        status: farm.status
      });
    }
  }

  convertToCSV() {
    for (var i = 0; i < this.parsedData.length; i++) {
      var line = '';
      for (var index in this.parsedData[i]) {
        if (line !== '') line += ',';

        line += this.parsedData[i][index];
      }

      this.csvString += line + '\r\n';
    }

    this.csvString = 'data:text/csv;charset=utf-8,' + this.csvString;
  }

  openInBrowser() {
    var encodedUri = encodeURI(this.csvString);
    var link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'export.csv');
    document.body.appendChild(link); // Required for FF

    link.click(); // This will download the data file named "my_data.csv".
  }
}

export { ToCSV };
